// ActiveAdmin has_many form handler - vanilla JavaScript (no jQuery)

function triggerEvent(element, eventName, detail = {}) {
  const event = new CustomEvent(eventName, {
    bubbles: true,
    cancelable: true,
    detail
  })
  element.dispatchEvent(event)
  return event
}

function closest(element, selector) {
  let current = element
  while (current && current !== document) {
    if (current.matches && current.matches(selector)) {
      return current
    }
    current = current.parentElement
  }
  return null
}

function getData(element, key) {
  return element.dataset[key] || element.getAttribute(`data-${key}`)
}

function setData(element, key, value) {
  element.dataset[key] = value
}

function recomputePositions(parent) {
  const inputName = getData(parent, 'sortable')
  if (!inputName) return

  let position = parseInt(getData(parent, 'sortableStart') || '0', 10)
  const fieldsets = parent.querySelectorAll(':scope > fieldset')

  fieldsets.forEach((fieldset) => {
    const destroyInput = fieldset.querySelector(`> ol > .input > input[name$='[_destroy]'], > ol > .input > select[name$='[_destroy]'], > ol > .input > textarea[name$='[_destroy]']`)
    const sortableInput = fieldset.querySelector(`> ol > .input > input[name$='[${inputName}]'], > ol > .input > select[name$='[${inputName}]'], > ol > .input > textarea[name$='[${inputName}]']`)

    if (sortableInput) {
      const isDestroyed = destroyInput && destroyInput.checked
      sortableInput.value = isDestroyed ? '' : position++
    }
  })
}

function initSortable() {
  const containers = document.querySelectorAll('.has_many_container[data-sortable]:not([data-sortable-initialized])')

  containers.forEach((container) => {
    container.setAttribute('data-sortable-initialized', 'true')

    // Use native HTML5 drag and drop or a lightweight library
    // For now, we'll skip sortable if no library is available
    // You can add SortableJS later if needed: npm install sortablejs
    console.log('Sortable functionality available if SortableJS is installed')
  })
}

// Handle remove button clicks
document.addEventListener('click', (event) => {
  const removeButton = closest(event.target, 'a.button.has_many_remove')
  if (!removeButton) return

  event.preventDefault()
  const parent = closest(removeButton, '.has_many_container')
  const toRemove = closest(removeButton, 'fieldset')

  if (!parent || !toRemove) return

  recomputePositions(parent)

  const beforeEvent = triggerEvent(parent, 'has_many_remove:before', { fieldset: toRemove, container: parent })
  if (!beforeEvent.defaultPrevented) {
    toRemove.remove()
    triggerEvent(parent, 'has_many_remove:after', { fieldset: toRemove, container: parent })
  }
})

// Handle add button clicks
document.addEventListener('click', (event) => {
  const addButton = closest(event.target, 'a.button.has_many_add')
  if (!addButton) return

  event.preventDefault()
  const parent = closest(addButton, '.has_many_container')
  if (!parent) return

  const beforeEvent = triggerEvent(parent, 'has_many_add:before', { container: parent })
  if (beforeEvent.defaultPrevented) return

  // Get index
  const currentIndex = parseInt(getData(parent, 'hasManyIndex') || '0', 10)
  const fieldsets = parent.querySelectorAll(':scope > fieldset')
  const index = currentIndex || (fieldsets.length - 1) + 1
  setData(parent, 'hasManyIndex', (index + 1).toString())

  // Get template and replace placeholder
  const placeholder = getData(addButton, 'placeholder')
  const html = getData(addButton, 'html')
  if (!html) return

  const regex = new RegExp(placeholder, 'g')
  const newHtml = html.replace(regex, index)

  // Create element from HTML
  const temp = document.createElement('div')
  temp.innerHTML = newHtml.trim()
  const fieldset = temp.firstElementChild

  if (fieldset) {
    addButton.parentNode.insertBefore(fieldset, addButton)
    recomputePositions(parent)
    triggerEvent(parent, 'has_many_add:after', { fieldset, container: parent })
  }
})

// Handle destroy checkbox changes for sortable
document.addEventListener('change', (event) => {
  const input = event.target
  // Use valid CSS selector instead of jQuery :input pseudo-selector
  if (!input.matches('.has_many_container[data-sortable] input[name$="[_destroy]"], .has_many_container[data-sortable] select[name$="[_destroy]"], .has_many_container[data-sortable] textarea[name$="[_destroy]"]')) return

  const hasMany = closest(input, '.has_many')
  if (hasMany) {
    recomputePositions(hasMany)
  }
})

// Initialize sortable on has_many_add:after
document.addEventListener('has_many_add:after', (event) => {
  initSortable()
  // Re-initialize search selects in the new fieldset
  if (window.initializeSearchSelects && event.detail && event.detail.fieldset) {
    setTimeout(() => window.initializeSearchSelects(event.detail.fieldset), 100)
  }
  // Re-initialize multiple selects in the new fieldset
  if (window.initializeMultipleSelects && event.detail && event.detail.fieldset) {
    setTimeout(() => window.initializeMultipleSelects(event.detail.fieldset), 100)
  }
  // Re-initialize comboboxes in the new fieldset
  if (window.initializeComboboxes && event.detail && event.detail.fieldset) {
    setTimeout(() => window.initializeComboboxes(event.detail.fieldset), 100)
  }
  // Re-initialize datepickers in the new fieldset
  if (window.initializeDatePickers && event.detail && event.detail.fieldset) {
    setTimeout(() => window.initializeDatePickers(event.detail.fieldset), 100)
  }
})

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSortable)
} else {
  initSortable()
}

// Re-initialize on navigation (for Turbolinks/SPA)
document.addEventListener('turbolinks:load', initSortable)
document.addEventListener('turbo:load', initSortable)
